import React from 'react';
import './ScorecardPopover.styl';
import classNames from 'classnames';
import {browserHistory} from 'react-router';
import urlParams from 'utils/urlParams';
import CircularScore from 'components/pure/utils/CircularScore';

export default ({items, fileUploadId, newCallCard}) => (
  <div>
    <h2 className="popover-header">Scorecards</h2>
    {items.map(item => (
      <div
        className={classNames('history-action-item', 'percentage-item', 'score-item')}
        key={item.id}
        onClick={() => {
          if (newCallCard) {
            console.log('do something useful here');
          } else {
            return browserHistory.push(
              '/scorecard' +
                urlParams({
                  fileUploadId: fileUploadId,
                  showReport: true,
                  scorecardId: item.context.scorecardId,
                })
            );
          }
        }}>
        <div className={classNames('percentage-wrapper', 'score-wrapper')}>
          <CircularScore percentage={item.context.score} />{' '}
        </div>
        {item.context.scorecardName}
      </div>
    ))}
  </div>
);
